import { NeoState } from '~/store';

export const selectExternalPartiesList = (state: NeoState) =>
  state?.integrations?.externalParties?.list || [];

export const selectExternalPartiesMap = (state: NeoState) => state.integrations.externalParties.map;
